import React from 'react';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { Reviews } from './components/Reviews';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { ShortTestimonials } from './components/ShortTestimonials';
import { FinalOffer } from './components/FinalOffer';
import { Objections } from './components/Objections';
import { PurchasePopup } from './components/PurchasePopup';
import { GYM_BG } from './data/content';
export function App() {
  return <div className="relative min-h-full w-full overflow-x-hidden bg-[#0a0a0a] text-white" data-id="element-0">
      {/* Fixed blurred gym background */}
      <div aria-hidden="true" className="fixed inset-0 z-0 bg-cover bg-center" style={{
      backgroundImage: `url(${GYM_BG})`
    }} data-id="element-1" />
      <div aria-hidden="true" className="fixed inset-0 z-0 bg-black/80 backdrop-blur-md" data-id="element-2" />

      {/* Content */}
      <main className="relative z-10 mx-auto w-full" data-id="element-3">
        <Hero data-id="element-4" />
        <Problems data-id="element-5" />
        <Modules data-id="element-6" />
        <Reviews data-id="element-7" />
        <Bonuses data-id="element-8" />
        <Comparison data-id="element-9" />
        <ShortTestimonials data-id="element-10" />
        <FinalOffer data-id="element-11" />
        <Objections data-id="element-12" />

        <footer className="px-5 pb-28 pt-4 text-center" data-id="element-13">
          <p className="text-[11px] leading-relaxed text-neutral-500" data-id="element-14">
            HYROX Definitivo 360 — Edición Coach · Producto digital · Todos los
            derechos reservados.
          </p>
        </footer>
      </main>

      <PurchasePopup data-id="element-15" />
    </div>;
}